import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogBody,
  DialogSurface,
  Button,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  dialog: {
    '&.fui-DialogSurface': {
      width: '450px',
    },
  },
  title: {
    wordBreak: 'break-word',
  },
});

export const ConfirmDialog = (props) => {
  const {
    isDisplayed,
    title,
    errorText,
    confirmString,
    cancelString,
    onClickConfirm,
    onClickCancel,
    isUiBlocked,
    warningMsg,
  } = props;

  const classes = useStyles();

  const DismissIcon = useMemo(() => <Dismiss20Regular onClick={onClickCancel} />, [onClickCancel]);

  return (
    <Dialog
      open={isDisplayed}
    >
      <DialogSurface id="asset-delete-confirmation-dialog" className={mergeClasses('confirmation-dialog', classes.dialog)}>
        <DialogBody>
          <DialogTitle className={classes.title} action={DismissIcon}>
            {title}
          </DialogTitle>
          <DialogContent>
            {
              warningMsg &&
                <div className="image-delete-warning warning-msg" style={{ color: 'rgb(168,0,0)' }}>
                  {warningMsg}
                </div>
            }
            {
              errorText &&
              <div className="image-delete-error delete-error" style={{ color: 'rgb(168,0,0)' }}>
                {errorText}
              </div>
            }
          </DialogContent>
          <DialogActions position="start">
            <Button
              disabled={errorText.length > 0 || isUiBlocked}
              className="dialog-confirm-button"
              onClick={onClickConfirm}
              appearance="primary"
            >
              {confirmString}
            </Button>
            <Button
              disabled={isUiBlocked}
              className="dialog-cancel-button"
              onClick={onClickCancel}
              appearance="secondary"
            >
              {cancelString}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  isDisplayed: PropTypes.bool.isRequired,
  isUiBlocked: PropTypes.bool,
  title: PropTypes.string.isRequired,
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  warningMsg: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmString: PropTypes.string.isRequired,
  cancelString: PropTypes.string.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  customStyle: PropTypes.shape({}),
};

ConfirmDialog.defaultProps = {
  errorText: '',
  warningMsg: '',
  isUiBlocked: false,
  customStyle: null,
};
